import { SplitText } from "gsap/SplitText"

// contentType: "paragraph" || "heading"
// textElement: the element to split

export const split = ({ contentType, textElement }) => {
  let element

  if (contentType === "paragraph") {
    element = textElement.querySelectorAll("p, a")
  } else {
    element = textElement
  }

  const text = new SplitText(element, {
    type: "lines",
    linesClass: "text-line"
  })

  text.lines.forEach(line => {
    const span = document.createElement("span")
    span.className = "line-container"
    span.innerHTML = line.innerHTML
    line.textContent = ""
    line.appendChild(span)
  })

  return text

}